module.exports = __webpack_public_path__ + "img/NA-Caribbean-mobile.46a69e48.png";